<script>
  import { onMount } from 'svelte';

  import dayjs from 'dayjs';
  import Button, { options as buttonOptions } from '@ctm/ui/Button';
  import { Plane, Close } from '@ctm/ui/Icons';
  import DatePicker from '@ctm/ui/DatePicker';
  import TimeSelect from '@ctm/ui/TimeSelect';
  import TextInput from '@ctm/ui/TextInput';
  import cardIn from '../../transitions/cardIn';
  import { formatFromApiDate, parseDate } from '../../util/date';

  import {
    dateFormat,
    NO_CHANGE_REASON_MESSAGES,
    track,
    trackingEvents
  } from '../../store/index.js';

  export let sector = undefined;
  export let change =  undefined;

  let isChanging = false;
  let changedSearch = undefined;
  let currentSearch = undefined;

  let NoChangeReasonMessage;
  
  $: {
    NoChangeReasonMessage = NO_CHANGE_REASON_MESSAGES[sector.NoChangeReason] || NO_CHANGE_REASON_MESSAGES.Default
  }

  function getCurrentSearch() {
    return Object.assign({}, currentSearch);
  }

  function onToggleClick() {
    if (!isChanging) {
      change = getCurrentSearch();
      track(trackingEvents.CHANGE_BOOKING_FLIGHT_SELECTED);
    } else {
      change = undefined;
      track(trackingEvents.CHANGE_BOOKING_FLIGHT_DESELECTED);
    }

    isChanging = !isChanging;
  }

  function travelDateToSearchTime(travelDate) {
    let parsedDate = parseDate(travelDate, 'YYYY-MM-DDTHH:mm');

    if (parsedDate.get('m') > 30) {
      parsedDate = parsedDate.set('m', 30);
    }

    if (parsedDate.get('m') < 30) {
      parsedDate = parsedDate.set('m', 0);
    }

    return parsedDate.format('h:mma');
  }

  onMount(() => {
    currentSearch = {
      origin: sector.Departure.Location,
      destination: sector.Arrival.Location,
      date: formatFromApiDate(sector.Departure.Date, 'DD/MM/YYYY'),
      minDate: dayjs().format('DD/MM/YYYY'),
      time: travelDateToSearchTime(sector.Departure.Date)
    };
  });
</script>

<div class="flightSearch">

  { #if isChanging }

  <div class="flightSearch_form" in:cardIn>
    <div class="flightSearch_header">
      <h3 class="flightSearch_header_title">New flight details</h3>

      <div class="flightSearch_header_actions">
        <Button on:click="{onToggleClick}" Icon={Close} type="{buttonOptions.type.LINK}"
          size="{buttonOptions.size.COMPACT}">
        </Button>
      </div>
    </div>

    <div class="flightSearch_body">
      <div class="flightSearch_row">
        <label class="flightSearch_row_label">Origin</label>

        <TextInput isDisabled showLock value="{change.origin}">
          <div class="locationInputPrepend" slot="prepend">
            <Plane />
          </div>
        </TextInput>
      </div>

      <div class="flightSearch_row">
        <label class="flightSearch_row_label">Destination</label>

        <TextInput isDisabled showLock value="{change.destination}">
          <div class="locationInputPrepend" slot="prepend">
            <Plane />
          </div>
        </TextInput>
      </div>

      <div class="flightSearch_row flightSearch_row-cols">
        <div>
          <label class="flightSearch_row_label">Date</label>
          <DatePicker bind:date="{change.date}" minDate="{ change.minDate }"></DatePicker>
        </div>

        <div>
          <label class="flightSearch_row_label">Time</label>

          <TimeSelect bind:selected="{change.time}" isClearable="{false}">
          </TimeSelect>
        </div>
      </div>
    </div>
  </div>

  { :else if sector.IsChangeable}

  <div class="flightSearch_toggle">
    <Button on:click="{onToggleClick}" size="{buttonOptions.size.COMPACT}" type="{buttonOptions.type.PRIMARY_LINK}"
      isOutlined isWide>
      Select a new flight
    </Button>
  </div>

  { :else }

  <div class="flightSearch_message">
    <div>{ NoChangeReasonMessage }</div>
  </div>

  { /if }
</div>

<style>
  .flightSearch {
    display: flex;
    flex-grow: 1;
    border-radius: 3px;
    background-color: #e7f2ff;
  }

  .flightSearch_form {
    width: 100%;
  }

  .flightSearch_header {
    border-bottom: 1px solid #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 25px;
  }

  .flightSearch_header_title {
    color: #2c3e50;
    font-size: 16px;
    font-weight: 600;
    margin: 0;
  }

  .flightSearch_body {
    padding: 25px;
  }

  .flightSearch_row:not(:last-child) {
    margin: 0 0 37px 0;
  }

  .flightSearch_row-cols div {
    margin: 0 0 37px 0;
  }

  .flightSearch_row_label {
    color: #2c3e50;
    font-size: 14px;
    font-weight: 500;
    display: block;
    margin: 0 0 7px 0;
  }

  .locationInputPrepend {
    color: #6e7a85;
    width: 20px;
    height: 20px;
  }

  .flightSearch_toggle {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100px;
  }

  .flightSearch_message {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #3f4f5f;
    font-size: 14px;
    min-height: 100px;
  }

  .flightSearch_message div {
    width: 50%;
    max-width: 200px;
    text-align: center;
  }

  @media (min-width: 1025px) {
    .flightSearch_row-cols {
      display: flex;
      justify-content: space-between;
    }

    .flightSearch_row-cols div {
      margin: 0;
      width: 48.5%;
    }
  }
</style>
